import unleashClient from 'services/unleashClient'
import { FEATURE_FLAG_FACTSET_KONG_LIMA } from 'constants/featureFlag'
import { apiEndpoints, factset } from 'config'

// Set by useAuth after validating/refreshing the OIDC token each page load.
// Prevents routing through Kong with a stale access token from a previous session.
let _oidcTokenConfirmed = false

/** @param {boolean} confirmed */
export function setOidcTokenConfirmed(confirmed) {
  _oidcTokenConfirmed = confirmed
}

/** @returns {boolean} Whether an active OIDC session exists */
function hasOidcSession() {
  const { oidcAuthority, oidcClientId } = factset
  if (!oidcAuthority || !oidcClientId) {
    return false
  }
  const raw = localStorage.getItem(`oidc.user:${oidcAuthority}:${oidcClientId}`)
  if (!raw) {
    return false
  }
  try {
    const user = JSON.parse(raw)
    return Boolean(user.refresh_token || (user.expires_at && user.expires_at > Date.now() / 1000))
  } catch {
    return false
  }
}

/** @returns {string} The base URL for API requests */
export function getApiBaseUrl() {
  const { irwinBaseUrl, kongLimaBaseUrl } = apiEndpoints
  if (
    kongLimaBaseUrl &&
    _oidcTokenConfirmed &&
    hasOidcSession() &&
    unleashClient().isEnabled(FEATURE_FLAG_FACTSET_KONG_LIMA)
  ) {
    return kongLimaBaseUrl
  }
  return irwinBaseUrl
}
